export default "__VITE_ASSET__BujZ$vZv__"